const STORAGE_KEY = "isugar_cookie_consent";
const EVENTO = "isugar:consent-change";

/**
 * Consentimento de cookies analíticos (LGPD).
 *
 * A chave `isugar_cookie_consent` já era gravada pelo banner, mas **nunca era
 * lida por ninguém**: PostHog e o Firebase Analytics subiam no boot, antes
 * mesmo do banner aparecer, e continuavam rodando depois de o usuário escolher
 * "Só essenciais". O texto do banner promete o contrário.
 *
 * Este módulo é a fonte única da resposta e avisa os coletores quando ela muda.
 * O que não depende dela é o monitoramento de erro: roda sempre, sem
 * identificador persistente, sustentado por legítimo interesse — ver
 * `analytics/posthogClient`.
 */

export const temConsentimentoAnalitico = () => {
  try {
    const bruto = localStorage.getItem(STORAGE_KEY);
    if (!bruto) return false; // opt-in: sem resposta, não coleta
    return JSON.parse(bruto)?.accepted === true;
  } catch {
    return false;
  }
};

export const jaRespondeuConsentimento = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};

export const registrarConsentimento = (aceito) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accepted: aceito, date: new Date().toISOString() }),
    );
  } catch {
    // localStorage indisponível: segue sem persistir, mas avisa os coletores
  }
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: { aceito } }));
};

/** @returns {() => void} função para cancelar a inscrição */
export const aoMudarConsentimento = (callback) => {
  const handler = (e) => callback(e.detail?.aceito ?? false);
  window.addEventListener(EVENTO, handler);
  return () => window.removeEventListener(EVENTO, handler);
};

export const CHAVE_CONSENTIMENTO = STORAGE_KEY;
